<template>
  <div class="container">
    <div class="panel-wrapper top">
      <div style="overflow: hidden;">
        <!-- <div class="title" style="float: left;">
          <el-radio-group v-model="active" size="small" @change="tabInit">
            <el-radio-button label="1">产品概览</el-radio-button>
            <el-radio-button label="2">产品总览</el-radio-button>
          </el-radio-group>
        </div> -->
        <div class="title" style="float: right;">近30天销量</div>
      </div>
      <div class="canvas">
        <div class="canvas-stage" ref="main" v-loading="loading2"></div>
      </div>
    </div>
    <div class="panel-wrapper bottom" v-if="active === '1'">
      <div class="classify">
        <classify @change="handleClassifyed" ref="classify"></classify>
        <el-link type="primary" :underline="false" class="show-detail" @click="showDetail">显示明细</el-link>
      </div>
      <div class="canvas-grid" v-if="formData">
        <div class="canvas-item" v-for="(item, index) in dimensions" :style="item.style" :key="index">
          <div class="canvas-stage" :ref="item.key" v-loading="loading"></div>
        </div>
      </div>
    </div>
    <div class="panel-wrapper bottom" v-if="active === '2'">
      <div class="canvas-grid" style="height: 100%">
        <div class="canvas-item" style="width: 50%; height: 100%; padding-left: 0; padding-top: 0; padding-bottom: 0;">
          <div class="canvas-stage" ref="overview" v-loading="loading3"></div>
        <el-button type="text" class="float-right" @click="showDetail1">查看</el-button>
        <div class="float-left">
          截至到
          <span>{{ this.myDate }}</span
          > 月，上新数<span>{{ this.overviewData.newProductTotal }}</span
          >共计销量<span>{{ this.overviewData.saleNumTotal}}</span>件
        </div>
        </div>
        <div class="canvas-item" style="width: 50%; height: 100%; padding-left: 0; padding-top: 0; padding-bottom: 0; padding-right: 0;">
          <div class="canvas-stage" ref="distribute" v-loading="loading4"></div>
        <el-button type="text" class="float-right" @click="showDetail2">查看</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import classify from './classify'

import mainMixin from './main.mixin'
import colorsMixin from './colors.mixin'
import lengthsMixin from './lengths.mixin'
import materialsMixin from './materials.mixin'
import pricesMixin from './prices.mixin'
import overview from './overview.mixin'
import distribute from './distribute.mixin'
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'GoodsAnalysis',
  components: { classify },
  mixins: [mainMixin, colorsMixin, lengthsMixin, materialsMixin, pricesMixin, overview, distribute, pagePathMixin],
  data() {
    return {
      active: '1',
      formData: null,
      dimensions: [],
      loading: false,
      loading2: false,
      loading3: false,
      loading4: false,
      overviewData: [],
      myDate: new Date().getMonth() + 1,
      categoryName: "沙发"
    }
  },
  mounted() {
    this.categoryName = this.$route.query.categoryName
    if(this.$route.query.categoryName){
      this.$refs.classify.categoryName = this.$route.query.categoryName
    }
    this.tabInit();
  },
  methods: {
    tabInit() {
      if(this.active === '1') {
        this.getMainChartData();
        this.getYearData();
      }else{
        
      }
    },
    getMainChartData() {
      this.loading2 = true;
      this.$q.goodsAnalysis.productAnalyze()
      .then(res=>{
        this.$refs['main'] && this.render_main(res.data,this.categoryName);
      })
      .finally(_=>{
        this.loading2 = false;
      })
    },
    handleClassifyed({formData, anotherOpt}) {
      this.formData = formData;
      this.filterValidDemension(anotherOpt);
      this.getChartData();
    },
    filterValidDemension(anotherOpt) {
      // 过滤出不为空的维度
      let dimensions = [];
      this.dimensions = [];
      Object.keys(anotherOpt).forEach(key=>{
        if(anotherOpt[key] && anotherOpt[key].length > 0) {
          dimensions.push({
            key: key
          });
        }
      });
      if(dimensions.length === 1) {
        dimensions[0]['style'] = {
          height: '100%',
          width: '100%',
          'padding-left': '0px',
          'padding-right': '0px',
          'padding-bottom': '0px',
        };
      }
      if(dimensions.length === 2) {
        dimensions[0]['style'] = {
          height: '100%',
          width: '50%',
          'padding-left': '0px',
          'padding-bottom': '0px',
        };
        dimensions[1]['style'] = {
          height: '100%',
          width: '50%',
          'padding-left': '0px',
          'padding-right': '0px',
          'padding-bottom': '0px',
        };
      }
      if(dimensions.length === 3) {
        dimensions[0]['style'] = {
          height: '100%',
          width: '50%',
          'padding-left': '0px',
          'padding-bottom': '0px',
        };
        dimensions[1]['style'] = {
          height: '50%',
          width: '50%',
          'padding-left': '0px',
          'padding-right': '0px',
        };
        dimensions[2]['style'] = {
          height: '50%',
          width: '50%',
          'padding-left': '0px',
          'padding-top': '0px',
          'padding-bottom': '0px',
          'padding-right': '0px',
        };
      }
      if(dimensions.length === 4) {
        dimensions[0]['style'] = {
          height: '50%',
          width: '50%',
          'padding-left': '0px',
        };
        dimensions[1]['style'] = {
          height: '50%',
          width: '50%',
          'padding-left': '0px',
          'padding-right': '0px',
        };
        dimensions[2]['style'] = {
          height: '50%',
          width: '50%',
          'padding-left': '0px',
          'padding-top': '0px',
          'padding-bottom': '0px',
        };
        dimensions[3]['style'] = {
          height: '50%',
          width: '50%',
          'padding-left': '0px',
          'padding-top': '0px',
          'padding-right': '0px',
          'padding-bottom': '0px',
        };
      }
      this.$nextTick(_=>{
        this.dimensions = dimensions;
      })
    },
    getChartData() {
      this.loading = true;
      let data = this.formData;
      this.$q.goodsAnalysis.productGroupAnalyze({data})
      .then(res=>{
        let {colorList, lengthList, materialList, priceList} = res.data;

        this.$refs['colors'] && this.$refs['colors'][0] && this.render_colors(colorList);
        this.$refs['lengths'] && this.$refs['lengths'][0] && this.render_lengths(lengthList);
        this.$refs['materials'] && this.$refs['materials'][0] && this.render_materials(materialList);
        this.$refs['prices'] && this.$refs['prices'][0] && this.render_prices(priceList);

        this.loading = false;
      })
    },
    showDetail() {
      this.openSubPage({
        path: '/goods-analysis-info',
        query: {
          ...this.formData
        }
      })
    },
    showDetail1() {
      this.openSubPage({
        path: '/newBehavior',
        query: {
          
        }
      })
    },
    showDetail2() {
      this.openSubPage({
        path: '/yearBehavior',
        query: {
          
        }
      })
    },
    /**
     * 产品总览
     */
    getYearData() {
      this.loading3 = true;
      this.loading4 = true;
      this.$q.goodsAnalysis.thisYearNewProduct({params: {
        year: new Date().getFullYear()
      }})
      .then(res=>{
        this.overviewData = res.data
        console.log('this.overviewData',this.overviewData);
        this.render_overview(res.data);
      })
      .finally(_=>{
        this.loading3 = false;
      })
      this.$q.goodsAnalysis.productSaleNum()
      .then(res=>{
        this.render_distribute(res.data);
      })
      .finally(_=>{
        this.loading4 = false;
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .container
    height 100%
    padding 0.1px
    box-sizing border-box
  .panel-wrapper
    margin 5px
    border-radius 5px
    overflow hidden
    &.top
      height calc(38% - 7.5px)
      background #ffffff
    &.bottom
      height calc(62% - 7.5px)
    .title
      padding 5px 10px
      font-size 14px
      position relative
      color #999
      display inline-block
    .canvas
      height calc(100% - 27px)
      width 100%
      background #ffffff
      padding 5px
      box-sizing border-box
    .canvas-stage
      background #fff
      border-radius 5px
      width 100%
      height 100%
    .canvas-grid
      height calc(100% - 40px)
      width 100%
      overflow hidden
      .canvas-item
        min-height 100px
        float left
        padding 5px
        box-sizing border-box
        position relative
    .classify
      background #ffffff
      overflow hidden
      padding 5px 10px
      border-radius 5px
      position relative

  .show-detail
    position absolute
    right 8px
    top 10px

  .float-right
    position absolute
    right 10px
    top 10px
    z-index 1000

  .float-left {
    position: absolute;
    left: 20px;
    top: 45px;
    z-index: 1000;
    font-size: 15px;
    color: #999999;

    span {
      color: #E6A23C;
    }
  }

  >>> .tooltips-scroll
    .infinity-scroll
      animation infinityScroll 10s infinite
      animation-fill-mode forwards

  @keyframes infinityScroll {
    0% {
      transform translate(0,0)
    }
    100% {
      transform translate(0,-100%)
    }
  }
</style>